import React from 'react';
import { getMessage } from 'util/locale';

const FailedToLoadContent = () => {
  return (
    <React.Fragment>{getMessage('text__failed-to-match-content')}</React.Fragment>
  );
};

export default FailedToLoadContent;
